import React from 'react';
import styled from 'styled-components';

const CloseBtn = ({onClick = ()=>{}, style = {}}) => {
return(
    <Container
        onClick={()=>{
            onClick()
        }}
        style={style}
    >
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M15 28.125C7.75126 28.125 1.875 22.2487 1.875 15C1.875 7.75126 7.75126 1.875 15 1.875C22.2487 1.875 28.125 7.75126 28.125 15C28.125 22.2487 22.2487 28.125 15 28.125ZM15 30C23.2843 30 30 23.2843 30 15C30 6.71573 23.2843 0 15 0C6.71573 0 0 6.71573 0 15C0 23.2843 6.71573 30 15 30Z"
                fill="white"/>
            <path
                d="M8.71209 8.71209C9.07821 8.34597 9.6718 8.34597 10.0379 8.71209L15 13.6742L19.9621 8.71209C20.3282 8.34597 20.9218 8.34597 21.2879 8.71209C21.654 9.07821 21.654 9.6718 21.2879 10.0379L16.3258 15L21.2879 19.9621C21.654 20.3282 21.654 20.9218 21.2879 21.2879C20.9218 21.654 20.3282 21.654 19.9621 21.2879L15 16.3258L10.0379 21.2879C9.6718 21.654 9.07821 21.654 8.71209 21.2879C8.34597 20.9218 8.34597 20.3282 8.71209 19.9621L13.6742 15L8.71209 10.0379C8.34597 9.6718 8.34597 9.07821 8.71209 8.71209Z"
                fill="white"/>
        </svg>
    </Container>
)

}
export default CloseBtn;

const Container = styled.div`
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    position: absolute;
    right: 10px;
    top: 10px;
    transition: all 0.2s;
    &:hover{
        transform: scale(1.1);
    }
`;